'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = Labels;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _propTypes3 = require('./helpers/propTypes');

var _propTypes4 = _interopRequireDefault(_propTypes3);

var _Dots = require('./Dots');

var _Dots2 = _interopRequireDefault(_Dots);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Renders labels for dots. Internally it's just a wrapper for [`<Dots>`](#dots) component
 * with `dotType="circle"`.
 *
 * @example ../docs/examples/Labels.md
 */
function Labels(props) {
    return _react2.default.createElement(_Dots2.default, _extends({}, props, { dotType: 'labels' }));
}

Labels.displayName = 'Labels';

Labels.propTypes = {
    className: _propTypes2.default.string,
    colors: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['category10', 'category20', 'category20b', 'category20c']), _propTypes2.default.arrayOf(_propTypes2.default.string), _propTypes2.default.func]),
    opacity: _propTypes2.default.number,
    style: _propTypes2.default.object,

    label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
    labelFormat: _propTypes2.default.func,
    labelAttributes: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),

    seriesVisible: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func]),
    seriesAttributes: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
    seriesStyle: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),

    groupStyle: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),

    dotVisible: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func]),
    dotAttributes: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
    dotStyle: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),

    seriesIndex: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.array, _propTypes2.default.func]),
    series: _propTypes4.default.series
};

Labels.defaultProps = {
    colors: 'category20',
    circleRadius: 4,
    ellipseRadiusX: 6,
    ellipseRadiusY: 4,
    seriesVisible: true,
    dotVisible: true
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/rumble-charts/lib/Labels.js
// module id = 1455
// module chunks = 0